<template>
    <div>
        <modal id="modal-new-noc-hcpcs-code" class="skintestblock" v-model="modal" :backdrop="false" size="lg">
            <h4 slot="title" class="smalltitle">{{getTitleModal}}</h4>
            <div class="block-body">
                <div class="prolabel note">HCPCS Code</div>
                <div class="profield">
                    <input type="text" v-model="nocCodeItem.CODE_HCPCS" @input="formatCode">
                </div>
                <div class="prolabel note">Description</div>
                <div class="profield">
                    <textarea v-model="nocCodeItem.Description" rows="8"></textarea>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="btn btn-default" @click.prevent="saveAction()">
                    <i class="fas fa-spinner fa-spin" v-if="processing"></i>
                    <span v-if="isEdit">Save</span>
                    <span v-if="!isEdit">Create</span>
                </button>
                <button type="button" class="btn btn-default" @click.prevent="modal = false">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'

export default {
  name: 'ModalNewNocHcpcsCode',
  mixins: [Common],
  props: {
    nocCodeEdit: {}
  },
  data () {
    return {
      modal: false,
      processing: false,
      nocCodeItem: {
        CODE_HCPCS: '',
        Description: ''
      }
    }
  },
  mounted () {
    if (this.nocCodeEdit) {
      this.getDetail()
      return
    }
    this.modal = true
  },
  computed: {
    getTitleModal () {
      if (this.nocCodeEdit) {
        return 'Edit NOC HCPCS Code'
      }
      return 'Create New NOC HCPCS Code'
    },
    isEdit () {
      if (this.nocCodeEdit) {
        return true
      }
      return false
    }
  },
  watch: {
    modal (newValue) {
      this.$emit('updateModal', newValue)
    }
  },
  methods: {
    formatCode () {
      this.nocCodeItem.CODE_HCPCS = (this.nocCodeItem.CODE_HCPCS || '').toUpperCase()
    },
    async getDetail () {
      try {
        const response = await axios.get(`/emr-data/noc-hcpcs-code/${this.nocCodeEdit._id}`)
        if (response.data.s === 200) {
          this.modal = true
          this.nocCodeItem = response.data.data.nocCode
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Server error when get data of NOC code.Try again ')
      }
    },
    validateForm () {
      if (!this.nocCodeItem.CODE_HCPCS) {
        return { s: false, msg: 'Please enter HCPCS code' }
      }
      return { s: true }
    },
    saveAction () {
      if (this.isEdit) {
        this.updateNocCode()
        return
      }
      this.createNocCode()
    },
    async updateNocCode () {
      if (this.processing) {
        return
      }
      const validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        const response = await axios.put(`/emr-data/noc-hcpcs-code/${this.nocCodeItem._id}`, this.nocCodeItem)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    },
    async createNocCode () {
      if (this.processing) {
        return
      }
      const validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        const response = await axios.post(`/emr-data/noc-hcpcs-code`, this.nocCodeItem)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    }
  }
}
</script>
